/**
 * @generated SignedSource<<895731980b820c0d83a8c4becc58ab38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletCounterparties_Query$variables = {
  slug: string;
  year?: number | null | undefined;
};
export type walletCounterparties_Query$data = {
  readonly walletCounterparties: ReadonlyArray<{
    readonly counterparty: string;
    readonly points: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly yearTotal: number;
  }>;
};
export type walletCounterparties_Query = {
  response: walletCounterparties_Query$data;
  variables: walletCounterparties_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "year"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "year",
    "variableName": "year"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "counterparty",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearTotal",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletCounterparties_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletCounterpartyRow",
        "kind": "LinkedField",
        "name": "walletCounterparties",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletCounterparties_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletCounterpartyRow",
        "kind": "LinkedField",
        "name": "walletCounterparties",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "33229566abb44bf84a02fd485b91fed9",
    "id": null,
    "metadata": {},
    "name": "walletCounterparties_Query",
    "operationKind": "query",
    "text": "query walletCounterparties_Query(\n  $slug: String!\n  $year: Int\n) {\n  walletCounterparties(slug: $slug, year: $year) {\n    counterparty\n    yearTotal\n    points {\n      month\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f943ac159b9e06f30b67ce3cd9233a2";

export default node;
